import "./insWorkspaceAnalysisEditMenu.scss";
import { AuxButton, AuxInlineMenu } from "@blk/aladdin-react-components-es";
import { AuxIconTypeEnum, AuxButtonTypeEnum, AuxButtonSizeEnum, AuxOverlayTriggerEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch } from "react-redux";
import { moveAnalysis, useDuplicateAnalysis } from "./helper/analysisHelpers";
import { useAllWorkspacesSelector } from "./hooks";
import { useDashboardFullPathInformations } from "./hooks/use-current-dashboard";
import { useUpdateAnalysesMutation } from "./store/api";
import { setDynamicText } from "./store/workspaces";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { MoveDirection } from "components/workspaces/left-pane/types";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setMessagesDialog } from "store/messages-dialog";
import { getCurrentLocalTime } from "common/date-utils";
export const InsWorkspaceAnalysisEditMenu = (props) => {
    const { panelIndex, analysisToEdit, analysesList } = props;
    const dispatch = useDispatch();
    const { handleDuplicateAnalysis } = useDuplicateAnalysis();
    const [updateAnalyses] = useUpdateAnalysesMutation();
    const { selectedWorkspace } = useDashboardFullPathInformations();
    const currentWorkspace = useAllWorkspacesSelector((w) => w.workspacesAndPreferences.find((wp) => wp.id === (selectedWorkspace ?? w.currentWorkspace)));
    const editMenu = [
        [
            {
                eventData: { action: () => handleDuplicateAnalysis(analysisToEdit).then(() => dispatch(setDynamicText(language.en.dashboard.duplicateAnalysisMsg))) },
                isDisabled: !currentWorkspace?.isEditable,
                label: language.en.dashboard.edit.duplicate,
                leftIcon: "duplicate"
            }
        ],
        [
            {
                eventData: {
                    action: () => {
                        moveAnalysis(MoveDirection.Up, panelIndex, analysesList, updateAnalyses);
                    }
                },
                isDisabled: !currentWorkspace?.isEditable,
                label: language.en.dashboard.edit.moveUp,
                leftIcon: "actionarrow-up"
            },
            {
                eventData: {
                    action: () => {
                        moveAnalysis(MoveDirection.Down, panelIndex, analysesList, updateAnalyses);
                    }
                },
                isDisabled: !currentWorkspace?.isEditable,
                label: language.en.dashboard.edit.moveDown,
                leftIcon: "actionarrow-down"
            }
        ],
        [
            {
                eventData: { action: () => {
                        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.DeleteAnalysis, properties: { LocalTimestamp: getCurrentLocalTime() } });
                        dispatch(setMessagesDialog({ customProp: analysisToEdit || {},
                            functionName: MessagesDialogFunctionName.DeleteAnalysis,
                            hasCustomFooter: false,
                            messages: [
                                { message: language.en.dashboard.edit.deleteAnalysisMsg(analysisToEdit.name, analysisToEdit.isDefault) }
                            ],
                            title: language.en.dashboard.edit.deleteAnalysis,
                            type: "alert-with-options" }));
                    } },
                hasAlert: true,
                iconState: currentWorkspace?.isEditable ? "alert" : "tertiary-subtle-button",
                isDisabled: !currentWorkspace?.isEditable,
                label: language.en.dashboard.edit.delete,
                leftIcon: "delete-small"
            }
        ]
    ];
    return React.createElement("div", { slot: "badge" },
        React.createElement(AuxInlineMenu, { data: editMenu, trigger: AuxOverlayTriggerEnum.PRESSED, onInlineMenuItemClicked: (e) => e.detail.element.eventData?.action() },
            React.createElement("div", { slot: "target" },
                React.createElement(AuxButton, { id: "AuxButtonEllipsis", icon: AuxIconTypeEnum.ellipsis, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.TERTIARY }))));
};
